import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import ProfileModal from './ProfileModal';
import DarkModeToggle from '../../components/DarkModeToggle';

const Header = ({ toggleSidebar, sidebarOpen }) => {
   const { user, logout } = useAuth();
   const navigate = useNavigate();
   const [showProfileModal, setShowProfileModal] = useState(false);

   const handleLogout = () => {
      logout();
      navigate('/login');
   };

   return (
      <>
         <header className="sticky top-0 z-30 bg-white dark:bg-dark-primary shadow-md">
            <div className="flex h-16 items-center justify-between px-4 sm:px-6">
               <div className="flex items-center gap-4">
                  <button
                     onClick={toggleSidebar}
                     className="rounded-lg p-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-secondary"
                     aria-label="Toggle sidebar"
                  >
                     {sidebarOpen ? (
                        <svg
                           xmlns="http://www.w3.org/2000/svg"
                           width="24"
                           height="24"
                           viewBox="0 0 24 24"
                           fill="none"
                        >
                           <path
                              d="M14.75 5.58854L9.25 12.0052L14.75 18.4219"
                              stroke="#49475D"
                              strokeWidth="1.44"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                           />
                        </svg>
                     ) : (
                        <svg
                           xmlns="http://www.w3.org/2000/svg"
                           width="24"
                           height="24"
                           viewBox="0 0 24 24"
                           fill="none"
                        >
                           <path
                              d="M9.25 5.58854L14.75 12.0052L9.25 18.4219"
                              stroke="#49475D"
                              strokeWidth="1.44"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                           />
                        </svg>
                     )}
                  </button>
               </div>

               <div className="flex items-center gap-4">
                  <DarkModeToggle />
                  <div className="flex items-center gap-3">
                     <div className="text-right">
                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
                           {user?.name || user?.email}
                        </p>
                        <p className="text-xs text-gray-500 dark:text-gray-400">Admin</p>
                     </div>
                     <div
                        onClick={() => setShowProfileModal(true)}
                        className="h-10 w-10 cursor-pointer rounded-full bg-blue-600 dark:bg-dark-accent flex items-center justify-center text-white font-semibold"
                     >
                        {(user?.name || user?.email || 'A').charAt(0).toUpperCase()}
                     </div>
                  </div>
                  <span
                     onClick={handleLogout}
                     className="dark:text-[#0dcaf0] text-[#25223D] cursor-pointer"
                  >
                     <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        fill="currentColor"
                        className="bi bi-power"
                        viewBox="0 0 16 16"
                     >
                        <path d="M7.5 1v7h1V1z" />
                        <path d="M3 8.812a5 5 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812" />
                     </svg>
                  </span>
               </div>
            </div>
         </header>
         {showProfileModal && (
            <ProfileModal onClose={() => setShowProfileModal(false)} user={user} />
         )}
      </>
   );
};

export default Header;
